export default __webpack_public_path__ + "static/media/Close.c9d61d89.svg";